import React from "react";
import { Dropdown, Button } from "antd";
import { MoreHorizontal } from "lucide-react";

type ActionItem = {
  key: string;
  label: React.ReactNode;
  type?: 'divider'; // Support AntD dividers
  disabled?: boolean; // Shown greyed out and not clickable
};

interface ActionMenuProps {
  items: ActionItem[];
  onSelect: (key: string) => void;
}

export default function ActionMenu({ items, onSelect }: ActionMenuProps) {
  return (
    <Dropdown
      trigger={["click"]}
      overlayClassName="custom-action-menu"
      menu={{
        onClick: ({ key }) => onSelect(String(key)),
        items: items.map((item) =>
          item.type === "divider"
            ? { type: "divider" as const }
            : {
                key: item.key,
                label: <div>{item.label}</div>,
                disabled: item.disabled,
              },
        ),
      }}
    >
      <Button type="text" className="flex items-center justify-center hover:bg-gray-100 rounded-md p-1" icon={<MoreHorizontal size={20} />} />
    </Dropdown>
  );
}